import React, { useLayoutEffect, useState } from 'react';
import { truncate } from 'lodash';

import { BarChartGroup } from '@magoosh/lib/charts';

import StatisticData from '../statistic_data';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  sections: string;
  filters: any;
}

const PerformanceByTypeChart: React.FC<Props> = (props) => {
  const loadingData = () => {
    const mathTypes = [
      { type: 'Data Interpretation', 'Correct': 65, 'CorrectColor': colors.gray85, 'Incorrect': 35, 'IncorrectColor': colors.grayLightest },
      { type: 'Multiple Answer', 'Correct': 50, 'CorrectColor': colors.gray85, 'Incorrect': 50, 'IncorrectColor': colors.grayLightest },
      { type: 'Multiple Choice', 'Correct': 60, 'CorrectColor': colors.gray85, 'Incorrect': 40, 'IncorrectColor': colors.grayLightest },
      { type: 'Numeric Entry', 'Correct': 40, 'CorrectColor': colors.gray85, 'Incorrect': 60, 'IncorrectColor': colors.grayLightest },
      { type: 'Quantitative Comp...', 'Correct': 70, 'CorrectColor': colors.gray85, 'Incorrect': 30, 'IncorrectColor': colors.grayLightest }
    ];

    const verbalTypes = [
      { type: 'Reading Comprehen...', 'Correct': 60, 'CorrectColor': colors.gray85, 'Incorrect': 40, 'IncorrectColor': colors.grayLightest },
      { type: 'Sentence Equivalence', 'Correct': 50, 'CorrectColor': colors.gray85, 'Incorrect': 50, 'IncorrectColor': colors.grayLightest },
      { type: 'Text Completion', 'Correct': 70, 'CorrectColor': colors.gray85, 'Incorrect': 30, 'IncorrectColor': colors.grayLightest }
    ];

    let result = [];

    if (!props.sections || props.sections === 'all') {
      result = [
        { name: 'Math', data: mathTypes },
        { name: 'Verbal', data: verbalTypes }
      ];
    } else {
      if (props.sections.indexOf('math') !== -1){
        result.push({ name: 'Math', data: mathTypes });
      }
      if (props.sections.indexOf('verbal') !== -1) {
        result.push({ name: 'Verbal', data: verbalTypes });
      }
    }

    return result;
  };

  const loadingPlaceholder = (
    <BarChartGroup
      borderRadius={8}
      chartProps={{ animate: false }}
      data={loadingData()}
      formatValueFn={(value) => `${value}%`}
      hideLegend
      horizontal
      indexBy="type"
    />
  );

  const formatStatisticData = (statisticData) => {
    const componentColors = {
      'Correct': colors.dataDarkBlue,
      'Incorrect': colors.dataMutedBlue
    };

    return statisticData.map((group) => {
      const data = group.data.map((dataPoints) => {
        let result = { type: truncate(dataPoints.name, { length: 20 }) };

        dataPoints.components.forEach((component) => {
          result[component.name] = component.value;

          const color = componentColors[component.name];
          if (color) {
            result[`${component.name}Color`] = color;
          }
        });

        return result;
      });

      return {
        name: group.name,
        data
      };
    });
  };

  if (!props.filters) {
    return loadingPlaceholder;
  } else {
    return (
      <StatisticData
        filters={props.filters}
        formatDataFn={formatStatisticData}
        name="performance_by_type"
      >
        <StatisticData.Loading>
          {loadingPlaceholder}
        </StatisticData.Loading>

        {/* @ts-ignore */}
        <BarChartGroup
          borderRadius={8}
          chartProps={{ animate: false }}
          formatValueFn={(value) => `${value}%`}
          hideLegend
          horizontal
          indexBy="type"
        />
      </StatisticData>
    );
  }
};

export default PerformanceByTypeChart;
